import styled from 'styled-components';

import Modal from 'react-modal';

import { FiltersPanel } from 'features/filters/components/FiltersPanel/FiltersPanel';
import { StickyFooter } from 'components/ToolkitV2/StickyFooter/StickyFooter';
import { media } from 'helpers/breakpoints';
import { CloseOutlineIc } from '@dsch/dd-icons';
const FILTERS_SIDE_DRAWER_WIDTH = '480px';

// http://reactcommunity.org/react-modal/accessibility/
Modal.setAppElement('#__next');

const StyledFiltersModal = styled(Modal)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  padding: 0;
  background-color: ${({ theme }) => theme.colors.WHITE};
  z-index: ${({ theme }) => theme.zIndices.MODAL};
  overflow-y: auto;
  outline: none;

  transform: translateX(-100%);
  transition: all 0.2s ease-in-out;

  .ReactModal__Overlay--after-open & {
    transform: translateX(0);
  }
  .ReactModal__Overlay--before-close & {
    transform: translateX(-100%);
  }

  ${media.medium} {
    width: ${FILTERS_SIDE_DRAWER_WIDTH};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const StyledFiltersPanel = styled(FiltersPanel)`
  padding: ${({ theme }) => theme.spacing.M16};
  flex: 1;
`;

const ResultsButtonFooter = styled(StickyFooter)`
  background: ${({ theme }) => theme.colors.WHITE};
  padding: ${({ theme }) => `0 ${theme.spacing.M16} ${theme.spacing.M16}`};
`;

const CloseIcon = styled(CloseOutlineIc)`
  top: 24px;
  right: 24px;
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  position: absolute;
  cursor: pointer;
`;

export {
  StyledFiltersModal,
  ResultsButtonFooter,
  StyledFiltersPanel,
  Content,
  CloseIcon,
};
